var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: { form: _vm.form, rules: _vm.rules, "label-width": "120px" },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c(
        "el-col",
        { attrs: { span: _vm.colSpan } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("billingPage.CustomerName"),
                prop: "cusName",
              },
            },
            [
              _c("BjSelectLov", {
                attrs: {
                  "option-list": _vm.customerList,
                  placeholder: _vm.$t("customerNameText"),
                },
                on: { change: _vm.changeCustomer },
                model: {
                  value: _vm.form.cusName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "cusName", $$v)
                  },
                  expression: "form.cusName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: _vm.colSpan } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("WarehouseManagement.form.chooseLogistics"),
                prop: "logisticsName",
              },
            },
            [
              _c("BjSelectLov", {
                attrs: {
                  "option-list": _vm.LogisticsSelectionData,
                  placeholder: _vm.$t("inputText"),
                },
                model: {
                  value: _vm.form.logisticsName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "logisticsName", $$v)
                  },
                  expression: "form.logisticsName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: _vm.colSpan } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t(
                  "businessLogisticsCompanyBusiness.table.ProfitMargin"
                ),
                prop: "profitMargin",
              },
            },
            [
              _c(
                "BjInputMoney",
                {
                  attrs: { placeholder: _vm.$t("inputText"), clearable: "" },
                  model: {
                    value: _vm.form.profitMargin,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "profitMargin", $$v)
                    },
                    expression: "form.profitMargin",
                  },
                },
                [_c("template", { slot: "append" }, [_vm._v("%")])],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: _vm.colSpan } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("AccountManagementAdd.from"),
                prop: "queryParamsTime_create",
              },
            },
            [
              _c("BjDateRangePicker", {
                attrs: { placeholder: _vm.$t("AccountManagementAdd.ps2") },
                model: {
                  value: _vm.queryParamsTime_create,
                  callback: function ($$v) {
                    _vm.queryParamsTime_create = $$v
                  },
                  expression: "queryParamsTime_create",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }